import { createAction } from '@reduxjs/toolkit'
export const CHANGE_OPENED_LEFT_SIDE_PANEL = '@sidePanel/CHANGE_OPENED_LEFT_SIDE_PANEL'
export const CHANGE_OPENED_RIGHT_SIDE_PANEL = '@sidePanel/CHANGE_OPENED_RIGHT_SIDE_PANEL'

export const changeOpenedLeftSidePanel = createAction<boolean>(CHANGE_OPENED_LEFT_SIDE_PANEL)
export const changeOpenedRightSidePanel = createAction<boolean>(CHANGE_OPENED_RIGHT_SIDE_PANEL)
